// Feature flags
import { DataType } from '@vendasta/automata';

export const initialTemplateCreationQueryParam = 'initialTemplateCreation';
export const PUBLISHING_PID = '';

export const TRIGGER_STEP_ID = 'trigger';

// All data types for automata-variable-menu usage
export const ALL_VARIABLE_MENU_DATA_TYPES = Object.values(DataType).filter((v) => typeof v === 'number') as DataType[];

export const parameterPassingValidReturnTypes = [
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.BOOLEAN', value: DataType.DATA_TYPE_BOOLEAN },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.STRING', value: DataType.DATA_TYPE_STRING },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.ACCOUNT_ID', value: DataType.DATA_TYPE_ACCOUNT_GROUP_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.ORDER_ID', value: DataType.DATA_TYPE_ORDER_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.USER_ID', value: DataType.DATA_TYPE_SMB_USER_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.UNKNOWN', value: DataType.DATA_TYPE_UNKNOWN },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.OPPORTUNITY_ID', value: DataType.DATA_TYPE_OPPORTUNITY_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.COMPANY_ID', value: DataType.DATA_TYPE_COMPANY_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CONTACT_ID', value: DataType.DATA_TYPE_CONTACT_ID },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.PRODUCT', value: DataType.DATA_TYPE_PRODUCT },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.TASK', value: DataType.DATA_TYPE_TASK },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.NOTE', value: DataType.DATA_TYPE_CRM_NOTE },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_EMAIL', value: DataType.DATA_TYPE_CRM_EMAIL },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_CALL', value: DataType.DATA_TYPE_CRM_CALL },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_MEETING', value: DataType.DATA_TYPE_CRM_MEETING },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_SMS', value: DataType.DATA_TYPE_CRM_SMS },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_INBOX', value: DataType.DATA_TYPE_CRM_INBOX },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_LINKEDIN', value: DataType.DATA_TYPE_CRM_LINKEDIN },
  {
    nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.INTEGRATION_CONNECTION',
    value: DataType.DATA_TYPE_INTEGRATION_CONNECTION,
  },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.NUMBER', value: DataType.DATA_TYPE_NUMBER },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CURRENCY', value: DataType.DATA_TYPE_CURRENCY },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.DATETIME', value: DataType.DATA_TYPE_DATETIME },
  { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.INVOICE', value: DataType.DATA_TYPE_INVOICE },
  {
    nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.CRM_CUSTOM_OBJECT_ID',
    value: DataType.DATA_TYPE_CRM_CUSTOM_OBJECT_ID,
  },

  // { nameKey: 'AUTOMATIONS.EDITOR.RETURN_VALUES.DATA_TYPES.JSON', value: DataType.DATA_TYPE_JSON },
];

export const ERROR_ICON_COLOR = '#d32f2f';
export const WARNING_ICON_COLOR = '#ffa000';
export const DISABLED_ICON_COLOR = '#e0e0e0';
export const INTERNAL_ICON_COLOR = '#1B5E20'; // $glxy-green-900
export const DEFAULT_TRIGGER_COLOR = '#2E7D32FF'; // $success-icon-color
